import { useTranslation } from 'react-i18next';
import { useConsent } from '../context/ConsentContext';
import { useEffect, useState } from 'react';

export default function CookieBanner() {
  const { t } = useTranslation();
  const { consent, acceptAll, rejectAll, openManager } = useConsent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(consent === null);
  }, [consent]);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6">
      <div className="max-w-3xl mx-auto bg-gray-900 border border-pink-600/30 rounded-xl shadow-2xl">
        <div className="p-4 sm:p-5 text-sm text-gray-200">
          <p className="mb-3">{t('consent.bannerText')}</p>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <button onClick={rejectAll} className="px-4 py-2 rounded-md border border-gray-700 hover:border-gray-600 text-gray-200">
              {t('consent.rejectAll')}
            </button>
            <button onClick={openManager} className="px-4 py-2 rounded-md border border-pink-600/40 text-pink-300 hover:text-white hover:border-pink-500">
              {t('consent.manage')}
            </button>
            <button onClick={acceptAll} className="px-4 py-2 rounded-md bg-pink-600 hover:bg-pink-700 text-white font-semibold">
              {t('consent.acceptAll')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


